import React from 'react';
import { formatTime, getTherapistName } from './utils';

function SuccessStep({ selectedCenter, selectedDate, selectedTime, guestInfo, guestSelections, unfilledForms, onBookAnother, upkeepApplied }) {
  return (
    <div className="step-content">
      <div className="booking-success">
        <div className="success-icon">✓</div>
        <h2>You're all booked!</h2>
        <p className="success-subtitle">A confirmation has been sent to {guestInfo?.email || 'your email'}.</p>

        {upkeepApplied && (
          <div className="bf-upkeep-notice" style={{ marginTop: 12 }}>
            10% upkeep discount applied!
          </div>
        )}

        {unfilledForms.length > 0 && (
          <div className="forms-prompt">
            <div className="forms-prompt-icon">📋</div>
            <h3 className="forms-prompt-title">Please complete your form{unfilledForms.length > 1 ? 's' : ''}</h3>
            <p className="forms-prompt-text">
              {unfilledForms.length === 1
                ? 'We need you to fill out a form before your appointment.'
                : `We need you to fill out ${unfilledForms.length} forms before your appointment.`}
            </p>
            <div className="forms-prompt-links">
              {unfilledForms.map((form, i) => (
                <a key={i} className="forms-prompt-btn" href={form.formUrl} target="_blank" rel="noopener noreferrer">
                  {form.name}{form.serviceName ? ` — ${form.serviceName}` : ''}
                </a>
              ))}
            </div>
          </div>
        )}

        <div className="success-details">
          <div className="success-detail-row">
            <span className="success-label">Date</span>
            <span className="success-value">{selectedDate?.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })}</span>
          </div>
          <div className="success-detail-row">
            <span className="success-label">Time</span>
            <span className="success-value">{selectedTime ? formatTime(selectedTime) : ''}</span>
          </div>
          <div className="success-detail-row">
            <span className="success-label">Location</span>
            <span className="success-value">{selectedCenter?.name}</span>
          </div>
          {guestSelections.map((guest, idx) => guest.services?.map((item, i) => (
            <div key={`${idx}-${i}`} className="success-detail-row">
              <span className="success-label">Service</span>
              <span className="success-value">{item.service.display_name || item.service.name} with {(item.therapist?.Id || item.therapist?.id) === 'any' ? 'Any Provider' : getTherapistName(item.therapist)}</span>
            </div>
          )))}
        </div>

        <div className="success-calendar-links">
          <p className="calendar-label">Add to your calendar</p>
          <div className="calendar-buttons">
            <a className="calendar-btn" href={(() => {
              if (!selectedDate || !selectedTime) return '#';
              const start = new Date(selectedTime);
              const totalMins = guestSelections.reduce((sum, g) => sum + (g.services || []).reduce((s, item) => s + (item.service.duration || 30), 0), 0);
              const end = new Date(start.getTime() + totalMins * 60000);
              const fmt = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
              const title = encodeURIComponent(`Cutie Pie Wax Bar - ${selectedCenter?.name}`);
              const details = encodeURIComponent(guestSelections.map(g => g.services?.map(i => i.service.display_name || i.service.name).join(', ')).join('; '));
              return `https://www.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${fmt(start)}/${fmt(end)}&details=${details}`;
            })()} target="_blank" rel="noopener noreferrer">
              Google Calendar
            </a>
            <a className="calendar-btn" href={(() => {
              if (!selectedDate || !selectedTime) return '#';
              const start = new Date(selectedTime);
              const totalMins = guestSelections.reduce((sum, g) => sum + (g.services || []).reduce((s, item) => s + (item.service.duration || 30), 0), 0);
              const end = new Date(start.getTime() + totalMins * 60000);
              const title = encodeURIComponent(`Cutie Pie Wax Bar - ${selectedCenter?.name}`);
              return `https://outlook.live.com/calendar/0/deeplink/compose?subject=${title}&startdt=${start.toISOString()}&enddt=${end.toISOString()}`;
            })()} target="_blank" rel="noopener noreferrer">
              Outlook
            </a>
            <button className="calendar-btn" onClick={() => {
              if (!selectedDate || !selectedTime) return;
              const start = new Date(selectedTime);
              const totalMins = guestSelections.reduce((sum, g) => sum + (g.services || []).reduce((s, item) => s + (item.service.duration || 30), 0), 0);
              const end = new Date(start.getTime() + totalMins * 60000);
              const fmt = (d) => d.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
              const ics = `BEGIN:VCALENDAR\nVERSION:2.0\nBEGIN:VEVENT\nDTSTART:${fmt(start)}\nDTEND:${fmt(end)}\nSUMMARY:Cutie Pie Wax Bar - ${selectedCenter?.name}\nEND:VEVENT\nEND:VCALENDAR`;
              const blob = new Blob([ics], { type: 'text/calendar' });
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url; a.download = 'booking.ics'; a.click();
            }}>
              Apple Calendar
            </button>
          </div>
        </div>

        <div className="success-social">
          <p className="social-label">Follow us for deals, tips & behind the scenes!</p>
          <div className="social-links">
            <a className="social-link instagram" href="https://www.instagram.com/cutiepiewaxbar/" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              Instagram
            </a>
            <a className="social-link tiktok" href="https://www.tiktok.com/@cutiepiewaxbar" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.48V13a8.28 8.28 0 005.58 2.15V11.7a4.83 4.83 0 01-3.77-1.24V6.69h3.77z"/></svg>
              TikTok
            </a>
            <a className="social-link facebook" href="https://www.facebook.com/cutiepiewaxbar/" target="_blank" rel="noopener noreferrer">
              <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              Facebook
            </a>
          </div>
        </div>

        <button className="auth-button" onClick={onBookAnother} style={{ marginTop: '30px' }}>
          BOOK ANOTHER APPOINTMENT
        </button>
      </div>
    </div>
  );
}

export default SuccessStep;
